export default __webpack_public_path__ + "static/media/QK_9131.e5159dc1.jpg";